<svg:rect
  [attr.width]="width"
  [attr.height]="height"
  [attr.rx]="em"
  [attr.fill]="node.color"
  [attr.stroke]="node.borderColor"
  [attr.data-testid]="'random-node-rect'"
  ></svg:rect>

  <svg:text
    class="mi"
    [attr.x]="0.5 * em"
    [attr.y]="0.5 * em"
    [style.font-size.px]="em"
    alignment-baseline="text-before-edge"
    text-anchor="start"
    [attr.fill]="node.frontColor"
    [attr.data-testid]="'random-node-icon'"
    >
    {{ node.icon }}
    </svg:text>

    <svg:text
      class="name"
      [attr.x]="2 * em"
      [attr.y]="0.25 * em"
      [style.font-size.px]="em"
      alignment-baseline="text-before-edge"
      text-anchor="start"
      [attr.fill]="node.frontColor"
      [attr.data-testid]="'random-node-name'"
      >
      {{ node?.display }}
      </svg:text>

      <svg:g
        class="junction"
        [index]="0"
        [dx]="0"
        [dy]="1 * em"
        type="input"
        [color]="node.borderColor"
        [node]="node"
        [attr.data-testid]="'random-node-input-junction'"
        ></svg:g>

        <svg:g class="conditions" [attr.data-testid]="'random-node-conditions'">
          @for (condition of node.conditions; track condition; let conditionIndex = $index) {
            <svg:g
              class="condition"
              [index]="conditionIndex + 1"
              [text]="condition.name"
              [color]="condition.color"
              [attr.data-testid]="'random-node-condition-' + conditionIndex"
              ></svg:g>
            }
            </svg:g>
